import { Component, Prop, Watch } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import { ToggleButton } from 'vue-js-toggle-button';
import moment from 'moment';

@Component({
  name: 'bpc-display-field-switch',
  components: {
    ToggleButton,
  },
})
export default class DisplayFieldSwitch extends mixins(AbstractDisplayField) {
  public isDisabled: boolean = false;

  mounted() {
    this.checkIfIsDisabled();
  }

  get switchValue(): boolean {
    if (
      this.value &&
      this.item &&
      this.fieldConfig &&
      this.fieldConfig.key &&
      this.fieldConfig.key == 'published'
    ) {
      const start = this.item.publish_start_date_time
        ? moment(this.item.publish_start_date_time)
        : null;
      const end = this.item.publish_end_date_time ? moment(this.item.publish_end_date_time) : null;
      const now = moment();
      if ((!start || start <= now) && (!end || now <= end)) {
        return true;
      } else {
        return false;
      }
    }
    return !!this.value;
  }

  get saveOnChange(): boolean {
    return this.fieldConfig.saveOnChange ?? false;
  }

  get entity(): string {
    return this.fieldConfig.entity;
  }

  get savePath(): string {
    return this.fieldConfig.savePath;
  }

  checkIfIsDisabled() {
    if (this.saveOnChange) {
      if (
        !this.$authorizationService.hasPermission('manage_activity_sessions') &&
        this.$authorizationService.hasPermission('manage_own_activity_sessions')
      ) {
        const userId = this.$authorizationService.getContactId();
        const responsibles = this.item.activity_session.responsibles;
        const isLoggedUserResponsible = !!responsibles.find(contact => contact.id === userId);
        this.isDisabled = !isLoggedUserResponsible;
      } else {
        this.isDisabled = false;
      }
    } else {
      this.isDisabled = true;
    }
  }

  onSwitchChange(data) {
    if (this.saveOnChange && this.entity && this.item?.id) {
      const path = this.$bpcApiRouteHelper.getEntityPath(this.entity) + '/' + this.item.id;
      const payload: object = { id: this.item.id };
      payload[this.fieldConfig.key] = data.value;

      this.$bpcApi.patch(path, payload).subscribe(
        res => {
          this.$emit('saved-on-change', res);
        },
        error => {
          this.$bpcMessage.showErrorMessage({ text: 'global.generic.error_form_action' });
        },
      );
    }
  }
}
